/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import React from 'react';
import styled from 'styled-components/macro';

// Use style component transient prop (with the dollar sign) for wrap
// otherwise it will complain about the boolean being passed
const Container = styled.ul<{ numSpaces: number; $wrap: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  ${(props) =>
    props.$wrap
      ? 'flex-wrap: wrap;'
      : `
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      `}
  li {
    ${(props) => !props.$wrap && 'white-space: nowrap;'}
  }

  /* Add delimiters between list items */
  li:not(:last-child)::after {
    color: ${(props) => props.theme.delimiterColor};

    /* On small window sizes, keep the delimiter on same line */
    white-space: nowrap;

    /* Use non-breaking space unicode so that last space appears on
       screen */
    content: '${(props) =>
      `${'\u00a0'.repeat(props.numSpaces)}|${'\u00a0'.repeat(
        props.numSpaces
      )}`}';
  }
`;

const DelimitedWordList: React.FC<{ numSpaces?: number; wrap?: boolean }> = ({
  numSpaces = 1,
  wrap = true,
  children,
}) => (
  <Container numSpaces={numSpaces} $wrap={wrap}>
    {children}
  </Container>
);

export { DelimitedWordList };
